var storage = {
  _get: function () {
    var data = JSON.parse(window.localStorage.getItem('LessonsFeedbackStatus') ?? "{}");
    return data ? data : {};
  },
  _set: function (data: any) {
    window.localStorage.setItem('LessonsFeedbackStatus', JSON.stringify(data));
  },
  clear: function () {
    localStorage.removeItem('LessonsFeedbackStatus');
  },
};

export const useLessonFeedbackStatusStorage = () => {
  const getFeedbackStatusWithLesson = (lessonId: any) => {
    var data = storage._get()
    return data[lessonId];
  }

  const setFeedbackStatusWithLesson = (lessonId: any, status: string) => {
    var data = storage._get();
    data[lessonId] = status;
    return storage._set(data);
  }

  const removeFeedbackStatusWithLesson = (lessonId: any) => {
    var data = storage._get();
    delete data[lessonId];
    return storage._set(data);
  }

  const removeFeedbackStatus = () => {
    return storage.clear();
  }

  return {getFeedbackStatusWithLesson, setFeedbackStatusWithLesson, removeFeedbackStatusWithLesson, removeFeedbackStatus};
}
